export enum UpdateStatuses {
  notStarted = 0,
  requested = 10,
  processing = 20,
  completeSuccessful = 30,
  completeError = 100
}
